export default "__VITE_ASSET__zt48YsIm__"